/**
 * Cometa Taller · Control de Cantidad (assets/src/cantidad.js)
 */

export function initCantidad() {
  const controles = document.querySelectorAll('.ct-cantidad-control');

  controles.forEach((ctrl) => {
    const btnMenos = ctrl.querySelector('.ct-cantidad-btn:first-child');
    const btnMas = ctrl.querySelector('.ct-cantidad-btn:last-child');
    const display = ctrl.querySelector('.ct-cantidad-numero');

    if (btnMenos && btnMas && display) {
      btnMenos.addEventListener('click', () => {
        let val = parseInt(display.textContent, 10) || 1;
        if (val > 1) {
          val--;
          display.textContent = val;
        }
      });

      btnMas.addEventListener('click', () => {
        let val = parseInt(display.textContent, 10) || 1;
        if (val < 99) {
          val++;
          display.textContent = val;
        }
      });
    }
  });
}
